import { Locale } from "src/lib/Intl";
import { Address } from "src/types/ctgraphql.d";
import { getPrettyLocale } from "./prettyLocale";

/*
 * this function format streetaddress based on locale
 * */
export const formatStreetAddress = (
  address: Address,
  locale: Locale
): string => {
  const format1Locates = ["pl", "nl", "es"];

  let formattedStreetAddress = `${address?.streetNumber || ""} ${
    address?.additionalStreetInfo || ""
  } ${address?.streetName || ""}`;

  if (format1Locates.includes(getPrettyLocale(locale))) {
    formattedStreetAddress = `${address?.streetName || ""} 
      ${address?.streetNumber || ""} ${address?.additionalStreetInfo || ""}`;
  }
  return formattedStreetAddress;
};
